<template>
    <div class="modal fade" id="viewOfferLetter">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printOfferLetter()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printOfferLetter">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>Letter Of Offer</strong></h4></td>
                          <td class="text-right" width="20%" v-if="seeRecord.user"><barcode v-bind:value="seeRecord.user.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <table class="table" v-if="seeRecord.user" >
                        <thead>
                          <td>
                            <b>
                              {{seeRecord.user.name}} <br>
                              <i>{{seeRecord.address}},</i><br> <i>{{seeRecord.city}},</i><i v-if="seeRecord.state">{{seeRecord.state.name}} -</i>  <i>{{seeRecord.pin}}</i><br>
                            </b>
                          </td>
                          <td class="text-right" v-if="seeRecord.branch">Branch: {{seeRecord.branch.name}} <br>Date: {{currDate | myDate}}</td>
                        </thead>
                      </table>
                      <p class="text-center text-bold">Sub: Job Offer</p>
                      <p>Dear <b v-if="seeRecord.user">{{seeRecord.user.name}}</b></p>
                      <p>We are pleased to offer you the position of <b v-if="seeRecord.designation">{{seeRecord.designation.name}}</b> in our Company <b>{{getCompanyRecord.companyName}}</b> based at <i>{{getCompanyRecord.address}},</i> <i v-if="seeRecord.state">{{seeRecord.state.name}} -</i>  <i>{{seeRecord.pin}}</i>.</p>
                      <p>Your immediate supervisor will be {{reportingmanager}}. We trust that your knowledge, skills and experience will be among our most valuable assets.</p>
                      <p>As discussed and agreed with you, you will be eligible to receive the following beginning on your joining date:</p>
                      <ul>
                        <li><b>Salary:</b> Annual gross starting salary of Rs.{{annualctc}}, subject to tax and other statutory deductions</li>
                        <li><b>Sales Incentive:</b> As per the prevailing company scheme (Only Applicable for Sales personnel)</li>
                        <li>Business Travel allowance and reimbursements as per company policy.</li>
                      </ul>
                      <p>This offer letter is valid till {{seeRecord.joiningDate | myDate}}.  Please send a signed copy of this letter indicating your acceptance to join and resignation acceptance letter from your current employer to our HR.</p>
                      <p>Your Appointment Letter will be issued on the date of joining. The joining formalities and induction will be carried out in our {{getCompanyRecord.address}} office.</p>
                      <p>Please submit the following documents to HR at the time of your joining:  </p>
                      <p>
                        (1) photocopies of your degree certificates,<br>
                        (2) certifications, if any, <br>
                        (3) experience/ relieving letters<br>
                        (4) two color passport-size photos, <br>
                        (5) latest salary slips from your previous organization and <br>
                        (6) proof of address.
                      </p>
                      <p>We look forward to welcome you aboard.</p>
                      <br><br><br><br><br><br><br><br>
                      <p>Sincerely, </p><br>
                      <p>For <b>{{getCompanyRecord.companyName}}</b></p>
                      <p>HR DEPARTMENT</p>
                      <p>Date: </p>
                      <p>Location: </p>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      currDate: new Date()
    }
  },
  methods: {
    printOfferLetter () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printOfferLetter').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    annualctc: '',
    reportingmanager: '',
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// OfferLetter.vue?4d4dfaef